// @ts-check
import { Component } from "../engine";
import { Vector2D } from "../engine/vector";
import { PLAYER_1, PLAYER_2, DIFFICULTY_MEDIUM, DIFFICULTY_HARD, LOGIC_GAME_INTRO, LOGIC_GAME_KICKOFF, LOGIC_GAME_FINISHED, EVENT_INGAME_PLAYER_JUMPS, EVENT_INGAME_TUTORIAL_NEXTSTEP, EVENT_GAME_PAUSE, EVENT_GAME_QUIT, EVENT_GAME_RESET, EVENT_GAME_SHARE, LOGIC_GAME_RUNNING, EVENT_INGAME_KICKOFF, EVENT_GAME_RESUME } from "../global";

/**
 * Game Input
 */
export class GameInput extends Component {
    constructor() {
        super();
        this.trigger = 0;
        this.inputT = new Vector2D();
        this.lastInputT = new Vector2D();
        this.temp = new Vector2D();
        this.diff = new Vector2D();
    }

    init() {
        // Set player AI attributes
        switch (this.state.difficulty) {
            case DIFFICULTY_HARD:
                this.aiReactionMin = -70;
                this.aiReactionMax = 10;
                this.aiPositioning = 0.9;
                this.aiJumpPossibility = 0.4;
                break;
            case DIFFICULTY_MEDIUM:
                this.aiReactionMin = -60;
                this.aiReactionMax = 10;
                this.aiPositioning = 0.75;
                this.aiJumpPossibility = 0.3;
                break;
            default:
                this.aiReactionMin = -50;
                this.aiReactionMax = 10;
                this.aiPositioning = 0.5;
                this.aiJumpPossibility = 0.2;
        }

        // Load jump sensibility
        this.jumpSensibility = this.state.jumpSensibility;
    }

    update() {
        // Init state
        var state = this.state;

        // Do not do anything if cancel menu is shown
        if (state.paused || state.logic == LOGIC_GAME_INTRO) {
            return;
        }

        // XXX /////////////////////
        var jump = this.engine.keydown[32] != undefined || this.engine.keydown[38] != undefined || this.engine.keydown[87] != undefined || this.engine.touch.jump;
        var left = this.engine.keydown[37] != undefined || this.engine.keydown[65] != undefined;
        var right = this.engine.keydown[39] != undefined || this.engine.keydown[68] != undefined;

        var player = state.player1;
        if (jump && player.position.y >= state.ground) {
            player.velocity.y = -state.playerJumpForce;
            this.engine.fireEvent(EVENT_INGAME_PLAYER_JUMPS);
        }

        if (this.engine.touch.move) {
            player.position.x = (1 - this.engine.touch.move) * -state.wall;
        }

        if (left || right) {
            if (player.target == undefined) {
                player.target = player.position.copy();
            }

            player.target.x = player.position.x + (left ? -1 : 1) * 15;
        }
        /////////////////////

        // Reset
        this.engine.touch.jump = false;
        this.engine.touch.move = null;

        // "AI!"
        // this.calculateAI(state, state.player1, state.ball);

        // "AI!"
        this.calculateAI(state, state.player2, state.ball);

        // Move player
        this.clampPlayerTarget(state, state.player1);
        this.movePlayer(state.player1);
        this.clampPlayerTarget(state, state.player2);
        this.movePlayer(state.player2);
    }

    input(event) {
        var state = this.state;

        // Escape
        if (event.which == 27) {
            this.engine.fireEvent(!state.paused ? EVENT_GAME_PAUSE : EVENT_GAME_RESUME);
        }

        if (state.logic == LOGIC_GAME_INTRO) {
            return this.engine.fireEvent(EVENT_INGAME_KICKOFF, 100);
        } else if (state.logic == LOGIC_GAME_FINISHED || state.paused) {
            return;
        }

        // Touch input
        if (event.type.indexOf("touch") === 0) {
            event.stopPropagation();
        }

        const w2 = window.innerWidth / 2;
        if (event.type == "touchstart") {
            for (let i = 0; i < event.touches.length; i++) {
                const touch = event.touches.item(i);
                if (touch.clientX > w2) {
                    this.engine.touch.jump = true;
                } else {
                    this.engine.touch.move = touch.clientX / w2;
                }
            }
        } else if (event.type == "touchmove") {
            for (let i = 0; i < event.touches.length; i++) {
                const touch = event.touches.item(i);
                if (touch.clientX < w2) {
                    this.engine.touch.move = touch.clientX / w2;
                }
            }
        } else if (event.type == "touchend") {
            // console.log(event);
        }

        /*
		
		////////////////////////////////////
		// Init
		var jump = false;
		var player = state.player1;
		var input = {
				
		};

		// Do not do anything if cancel menu is shown
		if (state.paused) {
		    return;
		}

		// Check if inverse projection matrix set
		if (state.projectionInv == null) {
		    return;
		}

		// Transform event coords to world coords
		Vector2D.transform(input.coords, state.projectionInv, inputT);

		// Only react on touch events to stop intro
		if (state.logic == LOGIC_GAME_INTRO) {
		    if (INPUT_MOTION_EVENT == input.type) {
				if (MotionEvent.ACTION_DOWN == input.action) {
				    this.trigger = state.logic;
				} else if (MotionEvent.ACTION_UP == input.action && this.trigger == state.logic) {
				    this.engine.fireEvent(EVENT_INGAME_KICKOFF);
				    this.trigger = 0;
				}
		    }

		    return;
		} else if (state.logic == LOGIC_GAME_FINISHED) {
		    if (INPUT_MOTION_EVENT == input.type) {
				if (MotionEvent.ACTION_DOWN == input.action) {
					this.trigger = state.logic;
				} else if (MotionEvent.ACTION_UP == input.action && this.trigger == state.logic) {
				    this.handleInputOnFinished(state);
				    this.trigger = 0;
				}
		    }

		    return;
		}

		// Transform inverse camera position
		this.inputT.x += -state.camera.x;

		// Handle motion event
		if (INPUT_MOTION_EVENT == input.type) {
		    if (state.tutorial != null && this.inputT.y < -25) {
				if (input.action == MotionEvent.ACTION_UP) {
					this.handleInputOnTutorial(state);
				}
		    } else {
				if (this.inputT.x <= 0) {
				    if (this.lastInputT.y - this.inputT.y >= this.jumpSensibility && input.action == MotionEvent.ACTION_MOVE) {
				    	jump = true;
				    } else {
						if (player.target != null) {
						    player.target.set(this.inputT);
						} else {
						    player.target = this.inputT.copy();
						}
				    }
				} else {
				    jump = true;
				}
		    }
		} else if (INPUT_KEY_EVENT == input.type) {
		    if (input.action == MotionEvent.ACTION_DOWN && (input.keycode == KeyEvent.KEYCODE_ENTER || input.keycode == KeyEvent.KEYCODE_DPAD_CENTER)) {
		    	jump = true;
		    }
		}

		// Jump!
		if (jump && player.position.y >= state.ground) {
		    player.velocity.y = -state.playerJumpForce;
		    this.engine.fireEvent(EVENT_INGAME_PLAYER_JUMPS);
		}

		// 
		this.lastInputT.set(this.inputT);*/
    }

    /**
     * @param player
     * @param ball
     */
    calculateAI(state, player, ball) {
        if ((state.logic != LOGIC_GAME_KICKOFF && state.logic != LOGIC_GAME_RUNNING) || state.tutorial != undefined) {
            return;
        }

        if ((player.id == PLAYER_1 && ball.position.x >= 0) || (player.id == PLAYER_2 && ball.position.x <= 0)) {
            return;
        }

        if (player.target == undefined) {
            player.target = player.position.copy();
        }

        // Init ai parameters
        var correctionX = (player.id == PLAYER_2 ? 1 : -1) * (player.radius * 0.25);
        var reactionYMin = this.aiReactionMin;
        var reactionYMax = this.aiReactionMax;
        var positioning = this.aiPositioning;
        var jumpPossibility = this.aiJumpPossibility;

        // Init
        var kickoff = state.logic == LOGIC_GAME_KICKOFF && state.turn == player.id;
        this.diff
            .set(player.position)
            .add(player.center)
            .sub(ball.position);
        var dist = this.diff.length();

        // Positioning?
        if (state.difficulty == DIFFICULTY_HARD) {
            player.target.x = ball.position.x + correctionX;
        } else if (ball.position.y > reactionYMin || kickoff) {
            var d = reactionYMax - reactionYMin;
            var k = ball.position.y - reactionYMin;
            positioning *= k / d;
            if (kickoff) {
                positioning = 1;
            }

            player.target.x = player.position.x + positioning * (ball.position.x - player.position.x) + correctionX;
        }

        // Jump?
        var jump = Math.random() < jumpPossibility;
        if (kickoff) {
            jump = state.kickoffWatch > 1000;
        }

        if (jump && (kickoff || dist < 60) && player.position.y >= state.ground - 0.2) {
            player.velocity.y = -state.playerJumpForce;
            this.engine.fireEvent(EVENT_INGAME_PLAYER_JUMPS);
        }
    }

    /**
     * @param state
     */
    clampPlayerTarget(state, player) {
        if (player.target != undefined) {
            var min = player.id == PLAYER_1 ? -state.wall : 0;
            var max = min + state.wall;
            if (player.target.x < min) {
                player.target.x = min;
            } else if (player.target.x > max) {
                player.target.x = max;
            }
        }
    }

    /**
     * @param player
     */
    movePlayer(player) {
        if (player.target != undefined) {
            player.velocity.x = (player.target.x - player.position.x) * player.acceleration;
        }
    }
}
